import { Component, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ISupplementLinkDialogData } from 'editing-tool/src/app/shared/components/paper/steps/supplements/supplement-link-dialog/supplement-link-dialog-data';
import { ValidationConstants, ValidationService } from 'sc-common';

@Component({
    templateUrl: './supplement-link-dialog.component.html',
    standalone: false
})
export class SupplementLinkDialogComponent implements OnDestroy {

    public readonly form: UntypedFormGroup;

    public requestInProcess = false;

    private readonly _destroy$ = new Subject<void>();

    private readonly _dialogData: ISupplementLinkDialogData;

    constructor(
        private readonly _formBuilder: UntypedFormBuilder,
        private readonly _dialogRef: DynamicDialogRef,
        dialogConfig: DynamicDialogConfig) {

        this.form = this._buildForm();

        this._dialogData = dialogConfig.data;
    }

    public ngOnDestroy(): void {

        this._destroy$.next();
        this._destroy$.complete();
    }

    public addSupplementLink(): void {

        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.requestInProcess = true;

        this._dialogData.action(this.form.value)
            .pipe(takeUntil(this._destroy$))
            .subscribe(
                () => {
                    this.requestInProcess = false;
                    this._dialogRef.close(true);
                });
    }

    private _buildForm(): UntypedFormGroup {

        return this._formBuilder.group(
            {
                link: [
                    null,
                    [Validators.required, ValidationService.websiteValidator]],
                description: [
                    null,
                    [Validators.required, ValidationService.alphaNumSymbolValidator, Validators.maxLength(ValidationConstants.Max500Length)]]
            });
    }
}
